import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://bedf56ca8ec9f6b8965c678b62990ccc@o4506932955512832.ingest.us.sentry.io/4506932955643904",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});